import clsx from 'clsx';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PageSubheader } from '../../../../shared/ui/page-subheader/PageSubheader';
import { TabSwitcher } from '../../../../shared/ui/tab-switcher/TabSwitcher';
import { Button } from '../../../../shared/ui/button/Button';
import { IconButton } from '../../../../shared/ui/icon-button/IconButton';
import { ChevronLeftIcon } from '../../../../shared/ui/icons';
import { selectCampaignCadencesSelectedTypeTab } from '../../../../features/campaign-cadences/store/campaignCadencesSlice';
import { CAMPAIGN_CADENCES_TYPE_TAB_KEY } from '../../../../features/campaign-cadences/constants/campaignCadencesTabs';
import { buildTypeTabs } from './lib/campaignCadencesTypeTabs';
import styles from './CampaignCadencesSubheader.module.css';

export function CampaignCadencesSubheader({
  isEditing,
  isSaving,
  hasChanges,
  isEmpty,
  canEdit,
  onEdit,
  onDiscard,
  onSave,
  onBack,
  onTypeTabChange,
}) {
  const activeTypeTab = useSelector(selectCampaignCadencesSelectedTypeTab);
  const isTriggersTab = activeTypeTab === CAMPAIGN_CADENCES_TYPE_TAB_KEY.TRIGGERS;

  const typeTabs = useMemo(
    () => buildTypeTabs(activeTypeTab, onTypeTabChange),
    [activeTypeTab, onTypeTabChange],
  );

  return (
    <PageSubheader
      left={
        <div className={clsx(styles.titleRow)}>
          <IconButton ariaLabel="Go back" onClick={onBack} size="sm">
            <ChevronLeftIcon aria-hidden />
          </IconButton>
          <h1 className={clsx(styles.title)}>Campaigns</h1>
        </div>
      }
      right={
        <div className={clsx(styles.right)}>
          <TabSwitcher items={typeTabs} ariaLabel="Campaign cadences type" />
          {isTriggersTab ? null : isEditing ? (
            <div className={clsx(styles.actions)}>
              <Button variant="outline" size="sm" onClick={onDiscard} disabled={isSaving}>
                Discard
              </Button>
              <Button
                variant="primary"
                size="sm"
                onClick={onSave}
                disabled={!hasChanges || isSaving}
              >
                Save
              </Button>
            </div>
          ) : canEdit ? (
            <Button variant="primary" size="sm" onClick={onEdit} disabled={isEmpty}>
              Edit
            </Button>
          ) : null}
        </div>
      }
    />
  );
}
